var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
    "dismiss": `Atmesti`
};


export {$c0d724c3e51dafa6$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
